// One place that tidies listings as they arrive from the API, so every page
// (cards, map, detail, search, SEO) shows the same clean data.

/**
 * Listings kept off the public site. 170 is the "Turaq.kg платформасы" test
 * post (10 rooms, 2000 m²) — delete it in the admin, then drop it from here.
 */
export const HIDDEN_LISTING_IDS = new Set<number>([170]);

export const isHiddenListing = (p: any) => HIDDEN_LISTING_IDS.has(Number(p?.id ?? p?.property_id));

/**
 * Older Bishkek listings were saved as region CHUI + district "bishkek"
 * (Bishkek is a city of republican significance, not part of Chuy oblast).
 * Show them as Bishkek everywhere. The SQL fix in BACKEND_TODO.md § 1
 * makes this a no-op once it runs.
 */
export function normalizeListing<T extends Record<string, any>>(p: T): T {
  if (!p || typeof p !== "object") return p;
  if (p.region === "CHUI" && p.district === "bishkek") return { ...p, region: "BISHKEK", district: "" };
  const district = normalizeDistrict(p.district);
  if (district !== p.district) return { ...p, district };
  return p;
}

/**
 * Districts typed by hand by older clients («leninski», «октябрьский») →
 * the directory id, so the UI shows «Ленин району» instead of the raw text.
 * The form only offers directory values now (DistrictSelect).
 */
const DISTRICT_ALIASES: Record<string, string> = {
  leninski: "leninsky",
  leninskiy: "leninsky",
  lenin: "leninsky",
  "ленинский": "leninsky",
  "ленин": "leninsky",
  oktyabrski: "oktyabrsky",
  oktyabrskiy: "oktyabrsky",
  oktyabr: "oktyabrsky",
  "октябрьский": "oktyabrsky",
  "октябрь": "oktyabrsky",
  pervomaiski: "pervomaisky",
  pervomayskiy: "pervomaisky",
  pervomaysky: "pervomaisky",
  "первомайский": "pervomaisky",
  sverdlovski: "sverdlovsky",
  sverdlovskiy: "sverdlovsky",
  "свердловский": "sverdlovsky",
};

export function normalizeDistrict<T>(raw: T): T {
  if (typeof raw !== "string") return raw;
  const key = raw.trim().toLowerCase().replace(/\s+(район|району|р-н|district)$/u, "");
  return (DISTRICT_ALIASES[key] ?? raw) as T;
}
